import Vue from "vue";
import Router from "vue-router";
import {store} from "@/store/store";


import Welcome from "../components/Welcome";
import Loading from "../components/Loading";
import FullMenu from "../components/FullMenu";
import ItemDetails from "../components/ItemDetails";
import Promotion from "../components/Promotion";
import MenuDisabled from "../components/MenuDisabled";
import HomeIndex from "@/components/home/HomeIndex.vue";
import NotFoundTab from "@/modules/notFound/NotFoundTab.vue";


import init from "@/router/middleware/init.middleware";
import ErrorTab from "@/components/ErrorTab.vue";
//import MenuTab from "@/modules/menu/MenuTab.vue";
import MenuTabNew from "@/modules/menu/MenuTabNew.vue";
import MenuSingle from "@/modules/menu/components/MenuSingle.vue";

Vue.use(Router)

const routes = [
    {
        path: "*",
        component: NotFoundTab
    },
    {
        path: '/',
        name: 'loading',
        component: Loading
    },
    {
        path: '/welcome',
        name: 'welcome',
        component: Welcome,
        meta: {
            middleware: init,
        }
    },
    {
        path: '/menu-disabled',
        name: 'menu_disabled',
        component: MenuDisabled,
    },
    {
        path: '/menu',
        name: 'menu',
        component: MenuTabNew,
        meta: {
            middleware: init,
        }
    },
    {
        path: '/menu/:id',
        name: 'menu-single',
        component: MenuSingle,
        props: true,
        meta: {
            middleware: init,
        }
    },
    {
        path: '/home',
        name: 'home',
        component: HomeIndex,
        meta: {
            middleware: init,
        }
    },
    {
        path: '/full-menu/:id?',
        name: 'full-menu',
        component: FullMenu,
        props: true,
        meta: {
            middleware: init,
        }
    },
    {
        path: '/item/:id',
        name: 'item',
        component: ItemDetails,
        props: true,
        meta: {
            middleware: init,
        }
    },
    {
        path: '/promotion/:id',
        name: 'promotion',
        component: Promotion,
        props: true,
        meta: {
            middleware: init,
        }
    },
    {
        path: '/error',
        name: 'error',
        props: true,
        component: ErrorTab,
    },
    {
        path: '/review',
        name: 'review',
        component: () => import("@/modules/review/ReviewTab.vue"),
        meta: {
            middleware: init,
        }
    },
    {
        path: '/tip',
        name: 'tip',
        component: () => import("@/modules/tip/TipsTab.vue"),
        meta: {
            middleware: init,
        }
    },
    {
        path: '/bill/payment/:orderId?',
        name: 'payment',
        props: true,
        component: () => import("@/modules/cart/CartPayInfo.vue"),
        meta: {
            middleware: init,
        }
    },
    {
        path: '/bill/:orderId?',
        name: 'bill',
        props: true,
        component: () => import("@/modules/cart/Cart.vue"),
        meta: {
            middleware: init,
        }
    },
    {
        path: '/result',
        name: 'result',
        component: () => import("@/modules/paymentResult/PaymentResultTab.vue"),
        meta: {
            middleware: init,
        }
    },
    {
        path: '/order-history',
        name: 'history',
        component: () => import("@/modules/cart/History.vue"),
        meta: {
            middleware: init,
        }
    },
]

const router = new Router({
    mode: 'history',
    routes
})

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({...context, next: nextMiddleware});
    };
}

router.beforeEach((to, from, next) => {

    // temporary set page title
    if (to.name !== undefined && !to.name !== null) {
        document.title = `${(to.name).charAt(0).toUpperCase() + (to.name).slice(1)}-tab`
    }

    const queryCn = to.query.cn || null,
        queryT = to.query.t || null,
        queryCode = to.query.code || null,
        queryRedirect = to.query.r || null;

    if(queryRedirect !== null) {
        store.dispatch('SET_REDIRECT', queryRedirect);
    }

    // initial loading
    if (queryCn !== null) {
        store.dispatch('FETCH_AND_SET_COMPANY_NAME', queryCn)
        store.dispatch("FETCH_AND_SET_INITIAL_APP_DATA", queryT)
    }

    if (queryT !== null) {
        store.dispatch('FETCH_AND_SET_TABLE_DATA', queryT)
    }

    if (queryCode !== null) {
        store.dispatch('FETCH_AND_SET_TABLE_DATA_FROM_QR_CODE', queryCode)
    }


    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({...context, next: nextMiddleware});
    }

    return next();
});


export default router;

